import "reflect-metadata";
import React from "react";
import ReactDOM from "react-dom/client";
import * as Sentry from "@sentry/react";
import "./index.css";
import App from "./App";
import {
  dependenciesContainer,
  initDependencies,
} from "@di/DependencyContainer";
import { DependencyProvider } from "@di/DependencyContext";
import buffer from "buffer";
import { ApolloClient, ApolloProvider, InMemoryCache } from "@apollo/client";
import { DependencyType } from "@di/DependencyType";
import "react-loading-skeleton/dist/skeleton.css";
import { AuthProvider } from "@components/auth-provider/AuthProvider";
import { ThemeProvider } from "@components/theme-provider";

/* eslint-disable @typescript-eslint/no-explicit-any */
(window as any).Buffer = (window as any).Buffer || buffer.Buffer;
const sentryEnvironment = import.meta.env.VITE_SENTRY_ENVIRONMENT ?? "local";
const tracePropagationTargets = [
  "localhost",
  import.meta.env.VITE_BACKEND_HOST,
].filter((target): target is string => Boolean(target));

Sentry.init({
  dsn: "https://3f44ad1bcb03c59c783b3befef7d8ede@sentry.pes.technology/4",
  environment: sentryEnvironment,
  sendDefaultPii: true,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
    Sentry.consoleLoggingIntegration({
      levels: ["debug", "info", "log", "warn", "error", "assert", "trace"],
    }),
  ],
  tracesSampleRate: 1.0,
  tracePropagationTargets,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  enableLogs: true,
});

(window as any).PES = {
  version: import.meta.env.VITE_VERSION ?? "unknown",
};

(async () => {
  const root = ReactDOM.createRoot(
    document.getElementById("root") as HTMLElement
  );
  await initDependencies();

  const apollo = dependenciesContainer.get<ApolloClient<InMemoryCache>>(
    DependencyType.ApolloClient
  );

  root.render(
    <React.StrictMode>
      <ThemeProvider defaultTheme="system" storageKey="ui-theme">
        <DependencyProvider container={dependenciesContainer}>
          <ApolloProvider client={apollo}>
            <AuthProvider issuer={import.meta.env.VITE_JWT_ISSUER}>
              <App />
            </AuthProvider>
          </ApolloProvider>
        </DependencyProvider>
      </ThemeProvider>
    </React.StrictMode>
  );
})();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals(console.log);
